<template>
  <v-container>
    <v-stepper v-model="step">
      <!-- Encabezado de pasos -->
      <v-stepper-header>
        <v-stepper-step step="1" :complete="step > 1">
          Selecciona el plan de gastos médicos ménores
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step step="2" :complete="step > 2">
          Datos básicos
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step step="3">
          Resumen
        </v-stepper-step>
      </v-stepper-header>

      <!-- Contenido de pasos -->
      <v-stepper-items>
        <!-- Paso 1 -->
        <v-stepper-content step="1">
          <v-row>
            <!-- <v-row>
            <v-col cols="12" md="4" v-for="plan in planes" :key="plan.id">
              <v-card outlined class="pa-4 text-center" :elevation="selectedPlan === plan.id ? 6 : 1"
                @click="selectedPlan = plan.id">
                <h3 class="subtitle-1 font-weight-bold">Desde {{ $formatCurrency(plan.costo) }} (Mensual)</h3>
                <div class="headline font-weight-bold my-2"> {{ plan.title }}</div>

                <div class="caption">Tipo: {{ plan.tipo }} - incluye:</div>

                <ul class="pl-4">
                  <li v-for="(item, i) in plan.beneficios" :key="i" class="mb-2 d-flex">
                    <v-icon color="success" small class="mr-2 flex-shrink-0">mdi-check-circle</v-icon>
                    <span class="body-2 grey--text text--darken-2"
                      style="display: block; flex: 1; word-break: break-word;" v-html="item"></span>
                  </li>
                </ul>
              </v-card>
            </v-col>
          </v-row> -->
            <v-container>
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th class="text-left text-h6">Beneficio</th>
                    <th v-for="plan in planes" :key="plan.id" class="text-center table-header">
                      {{ plan.title }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Beneficios -->
                  <tr v-for="(beneficio, i) in beneficiosUnicos" :key="i">
                    <td v-html="beneficio" class="text-left"></td>
                    <td v-for="plan in planes" :key="plan.id" class="text-center">
                      <v-icon v-if="plan.beneficios.some(b => b.includes(beneficio))" color="success" small>
                        mdi-check
                      </v-icon>
                      <v-icon v-else color="error" small>
                        mdi-close
                      </v-icon>
                    </td>
                  </tr>

                  <!-- Fila de selección de plan -->
                  <tr>
                    <td class="text-left font-weight-bold">Seleccionar</td>
                    <td v-for="plan in planes" :key="plan.id" class="text-center">
                      <v-btn small :color="selectedPlan === plan.id ? 'primary' : 'grey'"
                        @click="selectedPlan = plan.id">
                        {{ selectedPlan === plan.id ? 'Seleccionado' : 'SELECCIONAR' }}
                      </v-btn>
                    </td>
                  </tr>

                  <!-- Fila de precios -->
                  <tr>
                    <td class="text-left font-weight-bold">Total Anual</td>
                    <td v-for="plan in planes" :key="plan.id" class="text-center font-weight-bold">
                      <div v-if="preciosPlanes[plan.id]">
                        <div>
                          <span style="text-decoration: line-through; color: gray; margin-right: 5px;">
                            {{ $formatCurrency(preciosPlanes[plan.id]) }}
                          </span>
                          <span style="color: green; font-weight: bold;">
                            {{ $formatCurrency(preciosPlanes[plan.id] * 0.9) }}
                          </span>
                        </div>
                        <div style="font-size: 0.8em; color: #555;">
                          10% de descuento aplicado
                        </div>
                      </div>
                      <div v-else>Cargando...</div>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-container>

          </v-row>
          <v-row class="justify-end mt-3" no-gutters>
            <v-btn color="primary" class="mt-4" @click="step = 2" :disabled="!selectedPlan">
              Siguiente
            </v-btn>
          </v-row>
        </v-stepper-content>

        <!-- Paso 2 -->
        <v-stepper-content step="2">
          <v-form ref="formDatos" v-model="formValid">
            <v-text-field label="Nombre(s)" v-model="datos.nombre" :rules="[rules.ruleRequired]"></v-text-field>
            <v-text-field v-if="resumenPlan.tipo === 'Familiar'" label="Número de beneficiados"
              v-model.number="datos.NumIntegrantes"
              :rules="[rules.ruleRequired, value => (value <= 9) || 'Máximo 9 beneficiados']" type="number" step="1"
              min="1" max="9"></v-text-field>

            <v-text-field label="Teléfono" v-model="datos.telefono" :rules="[rules.ruleRequired]"
              v-mask="'### ### ####'" placeholder="444 655 2222"></v-text-field>
          </v-form>
          <v-row class="justify-end mt-3" no-gutters>
            <v-btn class="mt-4 mr-2" text @click="step = 1">Atrás</v-btn>
            <v-btn color="primary" class="mt-4" @click="step = 3" :disabled="!formValid">
              Siguiente
            </v-btn>
          </v-row>

        </v-stepper-content>

        <!-- Paso 3 -->
        <v-stepper-content step="3">
          <div class="headline font-weight-bold my-2"> Resumen de tu cotización</div>
          <!-- <h3 class="subtitle-1 mb-4">Resumen de tu cotización</h3> -->
          <v-row>
            <!-- Columna 1 -->
            <v-col cols="12" md="8">
              <p><strong>Plan:</strong> {{ resumenPlan.title }} ({{ resumenPlan.tipo }})</p>
              <p v-if="resumenPlan.tipo === 'Familiar'"><strong>Beneficiarios:</strong> {{ datos.NumIntegrantes }}</p>
              <p><strong>Nombre:</strong> {{ datos.nombre }}</p>
              <p><strong>Teléfono:</strong> {{ datos.telefono }}</p>
              <p><strong>Coberturas:</strong> Consultas y urgencias médicas</p>
              <ul class="pl-4">
                <li v-for="(item, i) in resumenPlan.beneficios" :key="i" class="mb-2 d-flex">
                  <!-- Ícono fijo a la izquierda -->
                  <v-icon color="success" small class="mr-2 flex-shrink-0">mdi-check-circle</v-icon>

                  <!-- Texto que ocupa todo el ancho restante -->
                  <span class="body-2 grey--text text--darken-2"
                    style="display: block; flex: 1; word-break: break-word;" v-html="item"></span>
                </li>
              </ul>
            </v-col>
            <!-- Columna 1 -->
            <v-col cols="12" md="4">
              <td v-if="preciosPlanes[this.selectedPlan]" class="text-center font-weight-bold" style="min-width:120px;">
                <div class="detalle-pago">
                  <div class="linea-pago">
                    <span>Precio:</span>
                    <span>{{ $formatCurrency(preciosPlanes[this.selectedPlan]) }}</span>
                  </div>
                  <div class="linea-pago descuento">
                    <span>- 10% descuento:</span>
                    <span>{{ $formatCurrency(preciosPlanes[this.selectedPlan] * 0.1) }}</span>
                  </div>
                  <div class="linea-pago gastos">
                    <span>+ Gastos de expedición:</span>
                    <span>{{ $formatCurrency(200) }}</span>
                  </div>
                  <div class="linea-pago total">
                    <span>Total:</span>
                    <span>{{ $formatCurrency(preciosPlanes[this.selectedPlan] * 0.9 + 200) }}</span>
                  </div>
                </div>
                <div class="texto-explicativo" style="margin-top:4px; font-size:0.75em; color:#888;">
                  <div>Opciones de pago:</div>
                  <div>Anual: sin recargo</div>
                  <div>Semestral: +3% → {{ $formatCurrency(preciosPlanes[this.selectedPlan] * 0.03) }}</div>
                  <div>Trimestral: +6% → {{ $formatCurrency(preciosPlanes[this.selectedPlan] * 0.06) }}</div>
                  <div>Mensual: +9% → {{ $formatCurrency(preciosPlanes[this.selectedPlan] * 0.09) }}</div>
                </div>
              </td>
              <td v-else>Cargando...</td>
              <!-- <v-row dense>
                <v-col v-for="(item, index) in precios" :key="index" cols="12" sm="6" md="3">
                  <v-card outlined class="pa-4 text-center hoverable">
                    <div class="subtitle-1 font-weight-bold mb-2">{{ item.periodicidad }}</div>
                    <div class="headline font-weight-bold primary--text mb-1">
                      {{ $formatCurrency(item.precio) }}
                    </div>
                    <div v-if="index === 0" class="caption grey--text mb-1">
                      + {{ $formatCurrency(item.gastosExp) }} gastos de expedición
                    </div>
                    <div class="subtitle-2 font-weight-bold mt-2">
                      Total primer pago:
                      <span class="primary--text">
                        {{ $formatCurrency(item.precio + (index === 0 ? item.gastosExp : 0)) }}
                      </span>
                    </div>
                    <v-btn color="primary" class="mt-4" block @click="seleccionarPago(item.periodicidad)">
                      Seleccionar
                    </v-btn>
                  </v-card>
                </v-col>
              </v-row>
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th class="text-left">Periodicidad</th>
                    <th class="text-right">Precio</th>
                    <th class="text-right">Precio con descuento</th>
                    <th class="text-right">Gastos de expedición</th>
                    <th class="text-right">Total primer pago</th>
                    <th class="text-right">Pagos subsecuentes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in precios" :key="index"
                    :class="index === 0 ? 'grey lighten-4 font-weight-bold' : ''">
                    <td>{{ item.periodicidad }}</td>
                    <td class="text-right">{{ $formatCurrency(item.precio) }}</td>
                    <td class="text-right">{{ $formatCurrency(item.precio * 0.9) }}</td>
                    <td class="text-right">{{ index === 0 ? $formatCurrency(item.gastosExp) : '-' }}</td>
                    <td class="text-right">
                      {{ $formatCurrency(item.precio * 0.9 + (index === 0 ? item.gastosExp : 0)) }}
                    </td>
                    <td class="text-right">{{ $formatCurrency(item.precio) }}</td>
                  </tr>
                </tbody>
              </v-simple-table> -->
            </v-col>
          </v-row>
          <v-row class="justify-end mt-3" no-gutters>
            <v-btn class="mt-4 mr-2" text @click="step = 2">Atrás</v-btn>

            <div class="d-flex flex-column align-items-end">
              <v-btn color="success" class="mt-4" @click="descargarCotizacion">
                ME INTERESA
              </v-btn>
              <span style="font-size: 0.85em; color: #ff9800; font-weight: bold; margin-top: 4px; text-align: right;">
                En menos de 24 horas esta cubierto.
              </span>
            </div>
          </v-row>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    step: 1,
    preciosPlanes: {},
    beneficiosUnicos: [
      'Diseñado especialmente para quienes tienen más de 50 años',
      'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en toda nuestra red hospitalaria',
      'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en Hospital La Bene San Luis',
      'Incluye a tus <b>familiares directos</b> como beneficiarios',
      'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles para ti y tus <b>beneficiarios</b>',
      'Consultas médicas con <b>especialistas</b>: 6 LUC ',
      'Paquete de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan'
    ],
    planes: [
      {
        id: '120412072729', title: 'Plus Familiar', costo: 1400, tipo: 'Familiar', edad: 'General', hospital: 'Red General',
        beneficios: [
          'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en toda nuestra red hospitalaria',
          'Incluye a tus <b>familiares directos</b> como beneficiarios',
          'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles para ti y tus <b>beneficiarios</b>',
          'Paquete de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan',
        ]
      },
      {
        id: '160307172129', title: 'La Bene Familiar', costo: 1200, tipo: 'Familiar', edad: 'General', hospital: 'La Bene',
        beneficios: [
          'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en Hospital La Bene San Luis',
          'Incluye a tus <b>familiares directos</b> como beneficiarios',
          'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles para ti y tus <b>beneficiarios</b>',
          'Paquete de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan'
        ]
      }, //, destacado: 'Más vendido'
      {
        id: '120427063818', title: 'Plus Individual', costo: 650, tipo: 'Individual', edad: 'General', hospital: 'Red General',
        beneficios: [
          'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en toda nuestra red hospitalaria',
          'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles inmediatamente',
          'Paquete de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan'
        ]
      },
      {
        id: '170308171754', title: 'Plus Individual 50', costo: 1200, tipo: 'Individual', edad: 'Mayores de 50', hospital: 'Red General',
        beneficios: [
          'Diseñado especialmente para quienes tienen más de 50 años',
          'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en toda nuestra red hospitalaria',
          'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles inmediatamente',
          'Paquete de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan'
        ]
      },
      {
        id: '160307172802', title: 'La Bene Individual 50', costo: 1100, tipo: 'Individual', edad: 'Mayores de 50', hospital: 'La Bene',
        beneficios: [
          'Diseñado especialmente para quienes tienen más de 50 años',
          'Atención de urgencias con cobertura de <b>$65,000 MXN</b> en Hospital La Bene San Luis',
          'Consultas médicas con <b>especialistas</b>: 6 LUC disponibles inmediatamente',
          'Paquete de consultas médicas con <b>tarifa especial</b> si las agotas antes de la vigencia del plan'
        ]
      }
    ],
    selectedPlan: null,
    datos: { nombre: "", telefono: "", NumIntegrantes: null },
    formValid: false
  }),
  mounted() {
    this.planes.forEach(plan => {
      this.obtenerPrecio(plan.id);
    });
  },
  computed: {
    resumenPlan() {
      return this.planes.find(p => p.id === this.selectedPlan) || {};
    },
    rules() {
      return this.$rules;
    }
  },
  methods: {
    descargarCotizacion() {
      console.log(this.selectedPlan)
      console.log(this.datos)
      console.log(this.resumenPlan)
      var url = `https://wa.me/${process.env.VUE_APP_BASE_PHONEWHATSWEB}?text=${encodeURIComponent('Hola quiero la promoción 10% ')}${this.resumenPlan.title}`;
      window.open(url, '_blank');
    },
    seleccionarPago(periodicidad) {
      console.log("Seleccionaste pago:", periodicidad);
    },
    obtenerPrecio(planId) {
      this.$http.get(`cotizacion/preciosCoberturas?IdPlan=${planId}`, {})
        .then(response => {
          if (response.status === 200) {
            if (response.data) {
              this.$set(this.preciosPlanes, planId, response.data);
            }
          }
        })
        .catch(() => {
        });
    }
  }
};
</script>
<style lang="scss">
.detalle-pago {
  display: flex;
  flex-direction: column;
  align-items: flex-end; // Alinea los números a la derecha
  font-size: 14px;

  .linea-pago {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 2px;

    &.descuento {
      color: red;
    }

    &.gastos {
      color: blue;
    }

    &.total {
      font-weight: bold;
      border-top: 1px solid #000;
      padding-top: 2px;
      margin-top: 2px;
    }
  }
}
</style>